<template>
  <div class="cd_nav-container">
    <nav class="cd_nav">
      <ul>
        <li><router-link :to="{ name: 'pollution' }">Pollution</router-link></li>
        <li><router-link :to="{ name: 'fish' }">Fishing</router-link></li>
        <li><router-link :to="{ name: 'guide' }">Reporting Guide</router-link></li>
        <li><a href="https://deckerscreek.org/">Friends of Deckers Creek
          <!-- <abbr title="Friends of Deckers Creek" >FODC</abbr> -->
        </a></li>
      </ul>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'Nav'
  }
</script>
